module.exports = __webpack_public_path__ + "img/robot4.png";